var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAIconPaperwork30 = function SvgAIconPaperwork30(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    stroke: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.2802 19.2882L19.4408 28.1298L15.0947 28.9989L15.9639 24.6534L24.808 15.8118C25.2674 15.3516 25.8909 15.093 26.5412 15.093C27.1915 15.093 27.8151 15.3516 28.2744 15.8118L28.2849 15.8211C29.2409 16.7799 29.2389 18.332 28.2802 19.2882Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7685 25.9749H4.75369C3.78515 25.9749 3 25.1836 3 24.2076V4.7673C3 3.79125 3.78515 3 4.75369 3H22.4053C23.3738 3 24.1611 3.79125 24.1611 4.7673V12.7201",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 8H19.5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 13L19.5 13",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 18H15.5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgAIconPaperwork30 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIzMCIgdmlld0JveD0iMCAwIDMwIDMwIiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMjguMjgwMiAxOS4yODgyTDE5LjQ0MDggMjguMTI5OEwxNS4wOTQ3IDI4Ljk5ODlMMTUuOTYzOSAyNC42NTM0TDI0LjgwOCAxNS44MTE4QzI1LjI2NzQgMTUuMzUxNiAyNS44OTA5IDE1LjA5MyAyNi41NDEyIDE1LjA5M0MyNy4xOTE1IDE1LjA5MyAyNy44MTUxIDE1LjM1MTYgMjguMjc0NCAxNS44MTE4TDI4LjI4NDkgMTUuODIxMUMyOS4yNDA5IDE2Ljc3OTkgMjkuMjM4OSAxOC4zMzIgMjguMjgwMiAxOS4yODgyWiIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgLz4KPHBhdGggZD0iTTExLjc2ODUgMjUuOTc0OUg0Ljc1MzY5QzMuNzg1MTUgMjUuOTc0OSAzIDI1LjE4MzYgMyAyNC4yMDc2VjQuNzY3M0MzIDMuNzkxMjUgMy43ODUxNSAzIDQuNzUzNjkgM0gyMi40MDUzQzIzLjM3MzggMyAyNC4xNjExIDMuNzkxMjUgMjQuMTYxMSA0Ljc2NzNWMTIuNzIwMSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgLz4KPHBhdGggZD0iTTcuNSA4SDE5LjUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIC8+CjxwYXRoIGQ9Ik03LjUgMTNMMTkuNSAxMyIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgLz4KPHBhdGggZD0iTTcuNSAxOEgxNS41IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiAvPgo8L3N2Zz4=";